import React from 'react';

import GenericInstrumentTable from 'reusable/InstrumentTable';
import SimplifiedOptionInstrumentTable from '../../../TraineeSession/SimplifiedOptions/SimplifiedOptionInstrumentTable';

type Props = React.ComponentProps<typeof GenericInstrumentTable> & {
  simplifiedOption?: boolean;
};

/** Selects the read-only class-19 table for trainers while leaving every legacy table path untouched. */
const TrainerInstrumentTable: React.FC<Props> = ({
  simplifiedOption,
  ...props
}) => {
  const optionInstruments = props.financialInstruments.filter(
    instrument => instrument.simplified_option !== undefined,
  );
  const ordinaryInstruments = props.financialInstruments.filter(
    instrument => instrument.simplified_option === undefined,
  );

  if (
    simplifiedOption ||
    (optionInstruments.length && !ordinaryInstruments.length)
  ) {
    return (
      <SimplifiedOptionInstrumentTable
        financialInstruments={optionInstruments}
        readOnly
        showDrawer={false}
      />
    );
  }

  if (optionInstruments.length) {
    return (
      <>
        <GenericInstrumentTable
          {...props}
          financialInstruments={ordinaryInstruments}
        />
        <SimplifiedOptionInstrumentTable
          financialInstruments={optionInstruments}
          readOnly
          showDrawer={false}
        />
      </>
    );
  }

  return <GenericInstrumentTable {...props} />;
};

export default TrainerInstrumentTable;
